<div class="container_dialog">
    <div class="header_popup header_popup_center">
      <div class="title_popup title_popup_center">
        <span>{{"organize.organize"|translate}}</span>
      </div>
      <button (click)="closed()">
        <mat-icon style="color: black;">close</mat-icon>
      </button>
    </div>
    <form class="display_form" [formGroup]="form">
      <div class="input_field">
        <label for="">{{"Categories.categories"|translate}}</label>
        <mat-chip-list #chipCategoryList>
          <mat-chip *ngFor="let category of categoriesSelected$ | async" (removed)="cancelCategory(category.id)">
            {{category.name}}
            <button *appHasPermission="{ module: 'product', action: 'edit' }" matChipRemove>
              <mat-icon style="color: #868E96;">cancel</mat-icon>
            </button>
          </mat-chip>
          <input *appHasPermission="{ module: 'product', action: 'edit' }" class="input_chip" [placeholder]="'inventory.categories' | translate" #fruitInput formControlName="categoryControl"
            [matAutocomplete]="autoCategory" [matChipInputFor]="chipCategoryList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
        </mat-chip-list>
        <mat-autocomplete #autoCategory="matAutocomplete">
          <ng-container *ngIf="filteredCategories$ | async as categories">
            <mat-option *ngFor="let category of categories" [value]="category.name" (click)="onCategorySelected(category)">
              {{category.name}}
            </mat-option>
            <ng-container *appHasPermission="{ module: 'product', action: 'create' }">
              <mat-option [value]="form.value.categoryControl"
                *ngIf="categories.length === 0 && form.value.categoryControl"
                (click)="addNewElement(form.value.categoryControl, 'category')">
                {{ "Categories.no_category_available"|translate}}
              </mat-option>
            </ng-container>
          </ng-container>
        </mat-autocomplete>
      </div>
      <div class="input_field">
        <label for="">{{"Labels.labels"|translate}}</label>
        <mat-chip-list #chipList>
          <mat-chip *ngFor="let tag of tagsSelected$ | async" (removed)="cancelTag(tag.id)">
            {{tag.name}}
            <button *appHasPermission="{ module: 'product', action: 'edit' }" matChipRemove>
              <mat-icon style="color: #868E96;">cancel</mat-icon>
            </button>
          </mat-chip>
          <input *appHasPermission="{ module: 'product', action: 'edit' }" class="input_chip" [placeholder]="'inventory.New_Label_placeholder' | translate" #fruitInput formControlName="tagControl"
            [matAutocomplete]="auto1" [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
        </mat-chip-list>
        <mat-autocomplete #auto1="matAutocomplete">
          <ng-container *ngIf="filteredTags$ | async as tags">
            <mat-option *ngFor="let tag of tags" [value]="tag.name" (click)="onTagSelected(tag)">
              {{tag.name}}
            </mat-option>
            <ng-container *appHasPermission="{ module: 'product', action: 'create' }">
              <mat-option [value]="form.value.tagControl" class="add_option"
                *ngIf="tags.length === 0 && form.value.tagControl"
                (click)="addNewElement(form.value.tagControl, 'tag')">
                <img src="assets/icones/add.svg" alt="">
               {{"common.add"|translate}} "{{ form.value.tagControl }}"
              </mat-option>
            </ng-container>
          </ng-container>
        </mat-autocomplete>
      </div>
    </form>
    <div class="submet_btns">
      <button class="save_btn_pop_up cancel_btn_pop_up" (click)="closed()">
        <span>{{"common.back"|translate | uppercase}}</span>
        <img src="../../../../../assets/icones/arrow_back.svg" alt="">
      </button>
      <button class="save_btn_pop_up blue_btn" *appHasPermission="{ module: 'product', action: 'edit' }" (click)="save()">
        <span> {{"common.save"|translate | uppercase}} </span>
        <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
      </button>
    </div>
  </div>
